<template>
  <wrapper project="detail" :request="request" :params="params" showAmount>
    <template slot="toolbar" slot-scope="scope">
      <tg-search-tool :data="searchData" @on-submit="handleSearch(scope.onSearch)">
        <el-input
          :placeholder="$t('component.form.input.placeholder.below_member')"
          v-model="searchData.targetName"
          class="tg-input"
          size="small"
          style="width: 200px"
          clearable
        ></el-input>
      </tg-search-tool>
    </template>
    <template slot="betContent" slot-scope="scope">
      <p v-if="scope.row['market']">
        <span>{{ scope.row["market"] }} {{ scope.row["selection"] }}</span>
        <span>@</span>
        <span class="text-red">{{ parseProfit(scope.row["profit"]) }}</span>
      </p>
    </template>
    <template slot="result_after" slot-scope="scope">
      <span
        :class="{ 'text-green': scope.value > 0, 'text-red': scope.value < 0 }"
      >{{ scope.formated }}</span>
    </template>
  </wrapper>
</template>

<script>
import wrapper from "./wrapper";
import TgSearchTool from "@/components/tool/TgSearchTool";
import minins from "./mixins";
import str from "@/utils/str";
import formatter from "@/utils/formatter";

export default {
  components: {
    wrapper,
    TgSearchTool,
  },
  data() {
    return {
      amounts: {},
      columns: [],
    };
  },
  mixins: [minins],
  computed: {
    username() {
      return this.params.username;
    },
    usernickname() {
      return this.params.usernickname;
    },
    request() {
      return {
        ...this.searchData,
        username: this.username,
      };
    },
  },
  mounted() {
    this.$store.commit("breadcrumb/add", {
      name: this.$route.name,
      params: this.$route.params,
      query: this.$route.query,
      path: this.$route.path,
      meta: {
        title: str.format(
          "[{0}] {1}({2})",
          this.params.title,
          this.username,
          this.usernickname
        ),
      },
    });
  },
  methods: {
    parseProfit(profit) {
      return formatter.format(profit, "percent");
    },
  },
};
</script>
